import { BaseIcon } from './BaseIcon';

const EuroIcon = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        d="M14 10H4M14 14H4M20 5.73295C18.7513 4.53456 16.918 4 14.5 4C9.5 4 7 6.28571 7 12C7 17.7143 9.5 20 14.5 20C16.918 20 18.7513 19.4654 20 18.2671"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default EuroIcon;
